import i18n from 'i18n';

import {
  ENABLED_NOTIFICATIONS,
  NEW_NOTIFICATION,
  CONVERSATIONS_ITEM_ACCEPT,
  CONVERSATIONS_ITEM_REJECT,
  CONVERSATIONS_ITEM_COMPLETE,
} from './type';
import { DEAL_STATUS } from 'constants/chatConstants';
import { showErrorMessage } from 'helpers/notifications';
import { socket } from 'helpers/socket';

export function enableNotifications() {
  return (dispatch) => {
    if (!socket.instance) {
      dispatch({ type: ENABLED_NOTIFICATIONS });
      return;
    }

    // Регистрируем обработчики событий сразу, а не только при connect
    // Это важно, потому что сокет может быть уже подключен

    // Удаляем старые обработчики, чтобы избежать дублирования
    socket.instance.off('notify.subscribe');
    socket.instance.off('entity.update');
    socket.instance.off('contact.update');
    socket.instance.off('error');
    socket.instance.off('connect_error');
    socket.instance.off('disconnect');
    socket.instance.off('connect');

    socket.instance.on('error', (error) => {
      console.log('🚀 ~ error ', error);
      showErrorMessage(i18n.t(error));
    });

    socket.instance.on('connect_error', () => {
      console.log('🚀 connect_error ');
      showErrorMessage(i18n.t('dialog.error.connection'));
    });

    socket.instance.on('disconnect', (reason) => {
      console.log('🚀 ~ io server disconnect ', reason);
      if (reason === 'io server disconnect') {
        // the disconnection was initiated by the server, you need to reconnect manually
        if (socket.instance) {
          socket.instance.connect();
        }
      }
      // else the socket will automatically try to reconnect
    });

    // Обработчик для события notify.subscribe - регистрируем сразу
    socket.instance.on('notify.subscribe', (data) => {
      dispatch({ type: NEW_NOTIFICATION, payload: data });
    });

    socket.instance.on('entity.update', (data) => {
      dispatch({ type: NEW_NOTIFICATION, payload: data });
      if (data.status === DEAL_STATUS.ACCEPTED) {
        dispatch({ type: CONVERSATIONS_ITEM_ACCEPT, payload: data });
      } else if (data.status === DEAL_STATUS.REJECTED) {
        dispatch({ type: CONVERSATIONS_ITEM_REJECT, payload: data });
      } else if (data.status === DEAL_STATUS.COMPLETED) {
        dispatch({ type: CONVERSATIONS_ITEM_COMPLETE, payload: data });
      }
    });

    socket.instance.on('contact.update', (data) => {
      dispatch({ type: NEW_NOTIFICATION, payload: data });
    });

    // Если сокет уже подключен, сразу подписываемся на комнату
    if (socket.instance.connected) {
      socket.instance.emit('notify.subscribe');
      socket.instance.emit('entity.update');
      socket.instance.emit('contact.update');
    }

    // Также подписываемся при подключении (на случай переподключения)
    socket.instance.on('connect', () => {
      if (!socket.instance) return;
      socket.instance.emit('notify.subscribe');
      socket.instance.emit('entity.update');
      socket.instance.emit('contact.update');
    });

    dispatch({ type: ENABLED_NOTIFICATIONS });
  };
}
